import { FORM_TOKENS_STORE_NAME } from '../../constants';
import { getFormTokenMetaKeyRange } from './getFormTokenMetaKeyRange';
import { openFormTokensDb } from './openFormTokensDb';

export const deleteAllFormTokenMetaRecords = async (
  storageKey: string
): Promise<boolean> => {
  const db = await openFormTokensDb();
  if (!db) {
    return false;
  }

  return new Promise<boolean>((resolve) => {
    try {
      const transaction = db.transaction(FORM_TOKENS_STORE_NAME, 'readwrite');
      transaction
        .objectStore(FORM_TOKENS_STORE_NAME)
        .delete(getFormTokenMetaKeyRange(storageKey));
      transaction.oncomplete = () => resolve(true);
      transaction.onerror = () => resolve(false);
      transaction.onabort = () => resolve(false);
    } catch {
      resolve(false);
    }
  });
};
